const MIN_PARALLEL_GZIP_DELTA_LIMIT = 50;
const PARALLEL_GZIP_RANDOM_THRESHOLD = 0.5;

export const EPOCH_ZERO_ISO = new Date(0).toISOString();

export function isEpochZeroTimestamp(value: unknown): boolean {
  return value === EPOCH_ZERO_ISO;
}

type ParallelGzipDeltaQueryInput = {
  operationName: string;
  variables?: {
    bins?: unknown;
    lastUpdated?: unknown;
    limit?: unknown;
  };
};

export function isParallelGzipDeltaQueryEligible({
  operationName,
  variables,
}: ParallelGzipDeltaQueryInput): boolean {
  if (!operationName.includes('DeltaQuery')) {
    return false;
  }

  const limit =
    typeof variables?.limit === 'number'
      ? variables.limit
      : Number(variables?.limit);
  const bins =
    typeof variables?.bins === 'number'
      ? variables.bins
      : Number(variables?.bins);

  return (
    Number.isFinite(bins) &&
    bins > 1000 &&
    Number.isFinite(limit) &&
    limit >= MIN_PARALLEL_GZIP_DELTA_LIMIT &&
    isEpochZeroTimestamp(variables?.lastUpdated)
  );
}

export function shouldUseParallelGzipForDeltaQuery({
  operationName,
  random = Math.random(),
  variables,
}: ParallelGzipDeltaQueryInput & {
  random?: number;
}): boolean {
  return (
    isParallelGzipDeltaQueryEligible({operationName, variables}) &&
    random > PARALLEL_GZIP_RANDOM_THRESHOLD
  );
}
